/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Investor_HintInputs */

const cs_clients_investor_hint = /** @type {(inputs: Clients_Investor_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investiční kritéria — odděleně od financování poptávky.`)
};

const en_clients_investor_hint = /** @type {(inputs: Clients_Investor_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investment criteria — separate from demand financing.`)
};

/**
* | output |
* | --- |
* | "Investment criteria — separate from demand financing." |
*
* @param {Clients_Investor_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_investor_hint = /** @type {((inputs?: Clients_Investor_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Investor_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_investor_hint(inputs)
	return cs_clients_investor_hint(inputs)
});